import { SortOrder } from '../sort-order';

export class EntityFilters {
  entityType: string[];
  identifier: string;
  sortField: string;
  sortOrder: SortOrder;
  measurementName?: string;
  measurementTypeUnit?: string;
}
